import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "@/views/LayoutView.vue";
import FailView from "@/views/FailView.vue";
import StatusView from "@/views/StatusView.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "*",
      name: "404",
      component: FailView,
    },
    {
      path: "/",
      name: "home",
      component: HomeView,
    },
    {
      path: "/status/:submissionId/:uid",
      name: "status",
      component: StatusView,
    },
    {
      path: "/:operationId/status/:submissionId/:uid",
      name: "status_id",
      component: StatusView,
    },
    {
      path: "/:operationId",
      name: "home_id",
      component: HomeView,
    },
  ],
});

export default router;
